<!-- //hedaer section -->
 <div class="hpanel">
  <div class="panel-body">
    <div class="header-section">
      <div class="left-section">
          <h2>Email Notification Preferences</h2>
          <!-- <label id="button" class="switch">
            <input type="checkbox" class="checkbox">
            <span class="slider round1"></span>
          </label> -->
          <!-- <div class="custom-checkbox">
            <label class="checkbox-label font-bold" style="text-align: center;margin-top: -4px;"> 
              <input type="checkbox" >
              <span class="checkmark" title="Restrict Notifications"></span>
            </label>
          </div> -->
      </div>
  
      <div class="header-actions">
          <!-- <i class="material-icons edit-icon">edit</i>
          <button class="cancel">Cancel</button>
          <button class="save">Save</button> -->
      </div>
  </div>
  
  
  
    <hr>
  <!-- //body section -->
    <div class="notification-preferences">
      <div *ngFor="let category of notificationList; let i = index" class="bodysection">
        <div class="table-wrapper" [style.width]="(i === notificationList.length - 1) && (i % 2 === 0) ? '49%' : '100%'">
          <!-- Table header -->
          <table class="full-width">
            <thead class="btn-primary">
              <tr>
                <th style="text-align: center;">S.No.</th>
                <th style="width: 64%;">
                  <div class="custom-checkbox">
                    <label class="checkbox-label font-bold" style="text-align: center; margin-top: -4px;">
                      <input type="checkbox" [checked]="isCategoryChecked(category)" (change)="toggleCategory(category, $event)">
                      <span class="checkmark" style="top: -10px; border-color: #fff;" title="Turn"></span>
                    </label>
                  </div>
                  {{ category.category }} ({{ category.items?.length }})
                </th>
                <th style="text-align: center;">In App</th>
                <th style="text-align: center;">Email</th>
              </tr>
            </thead>
          </table>
  
          <!-- Scrollable tbody -->
          <div class="tbody-scroll">
            <table class="full-width">
              <tbody>
                <tr *ngFor="let item of category.items;let j = index">
                  <td style="text-align: center;">{{j+1}}.</td>
                  <td style="width: 64%;">{{ item.description }}</td>
                  <td style="text-align: center;">
                    <div class="custom-checkbox">
                      <label class="checkbox-label font-bold" style="text-align: center; margin-top: -4px;">
                        <input type="checkbox"
                              [(ngModel)]="notificationSettings[category.category][item.notifyType].inApp"
                              [disabled]="notificationSettings[category.category][item.notifyType].type === 'EMAIL' ||
                              notificationSettings[category.category][item.notifyType].defaultNotify">
                        <span class="checkmark" style="top: -10px;" title="Restrict Notifications"></span>
                      </label>
                    </div>
                  </td>
                  <td style="text-align: center;">
                    <div class="custom-checkbox">
                      <label class="checkbox-label font-bold" style="text-align: center; margin-top: -4px;">
                        <input type="checkbox"
                              [(ngModel)]="notificationSettings[category.category][item.notifyType].email"
                              [disabled]="notificationSettings[category.category][item.notifyType].type === 'NOTIFICATION' ||
                              notificationSettings[category.category][item.notifyType].defaultNotify">
                        <span class="checkmark" style="top: -10px;" title="Restrict Notifications"></span>
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>    
    </div>

    <div class="" *ngIf="!isLoading && notificationList.length == 0">
        <app-nodata-found [title]="['No data found to display.']"></app-nodata-found>
    </div>

    <ng-container *ngFor="let item of 5 | times; let i = index">
      <app-common-skeleton *ngIf="isLoading" [NameOftheScreen]="'notification-config'"></app-common-skeleton>
    </ng-container>


  <!-- //footer section -->
    <hr>
    <div class="button-group">
      <!-- <button class="cancel">Cancel</button> -->
      <button class="save" [disabled]="notificationList.length == 0" (click)="save()">Save Changes</button>
    </div>
  </div>
</div>
